// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"456":"dd27fb35","842":"14bbaf94","979":"d7212a60"}[chunkId] + ".js";
};